import getDeviceInfo from '../../../../commons/deviceInfo';

export async function getClientInfo(params) {
    const deviceInfo = await getDeviceInfo();
    this.clientInfo = { ...params, deviceInfo };
}

export default getClientInfo;
